import {gsap} from "gsap";
import * as HLF from "html-living-framework";
import * as springroll from "springroll";
import * as CaptionData from "../../json/close-caption.json";
import {CaptionToken} from "../Data/CaptionToken";

export interface ICaptionRenderer extends springroll.IRender {
    visible: boolean;
    onResize(pSize: PIXI.Point): void;
}

export class CaptionManager {

    private static _instance: CaptionManager;

    private _active: boolean;
    private readonly _data: any;
    private _player: springroll.CaptionPlayer | undefined;
    private _renderer: ICaptionRenderer | undefined;

    constructor() {
        this._active = true;
        this._data = (CaptionData as any).default;

        PubSub.subscribe(HLF.PLAY_CAPTION, this.onPlayCaptionRequested.bind(this));
        PubSub.subscribe(HLF.STOP_CAPTION, this.onStopCaptionRequested.bind(this));
    }

    static get instance() {
        return this._instance || (this._instance = new CaptionManager());
    }

    public get active(): boolean {
        return this._active;
    }

    public set active(pValue: boolean) {
        this._active = pValue;
        if (this._renderer !== undefined) {
            this._renderer.visible = this._active;
        }
    }

    public getCaption(vo: string) {
        const data = this._data[vo];
        if (data) {
            return data[0].content;
        }
        return "";
    }

    public getDuration(vo: string, index = 0) {
        const data = this._data[vo];
        if (data) {
            return (data[index].end - data[index].start) / 1000;
        }
        return NaN;
    }

    public setRenderer(pRenderer: ICaptionRenderer): void {
        this._renderer = pRenderer;
        this._renderer.visible = this._active;
        if (this._player === undefined) {
            this._player = new springroll.CaptionPlayer(this._data, this._renderer);
        } else {
            this._player.renderer = this._renderer;
        }
    }

    public playCaption(pId: string, pStart = 0, pArgs?: any): void {
        if (this._player !== undefined) {
            this._player.start(pId, pStart, pArgs);
            const data = this._data[pId];
            let d = this.getDuration(pId, 0);
            if (!isNaN(d)) {
                const activeCaption = this._player.activeCaption;
                // Support of long text in captions
                for (let i = 1; i < data.length; i++) {
                    ((dd: number) => {
                        gsap.delayedCall(d, () => {
                            if (this._player!.activeCaption === activeCaption) {
                                this._player!.start(pId, dd * 1000, pArgs);
                            }
                        });
                    })(d);
                    d += this.getDuration(pId, i);
                }
                // Springroll caption player does not stop the caption even if the update function is called
                gsap.delayedCall(d, () => {
                    if (this._player!.activeCaption === activeCaption) {
                        this.stopCaption();
                    }
                });
            }
        }
    }

    public stopCaption(): void {
        if (this._player !== undefined) {
            this._player.stop();
        }
    }

    public onResize(pSize: PIXI.Point): void {
        if (this._renderer !== undefined) {
            this._renderer.onResize(pSize);
        }
    }

    private onPlayCaptionRequested(pTopic: string, pToken: CaptionToken): void {
        this.playCaption(pToken.id, pToken.start, pToken.args);
    }

    private onStopCaptionRequested(pTopic: string, pToken: CaptionToken): void {
        this.stopCaption();
    }
}
